/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../../../../Fixes';
import Builder from '../../../../../../../../Builder';
import '../../../../../../../fulfillment/behaviors/client/fulfillment_methods_client';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "devicesettings": {
        "nested": {
          "profiles": {
            "nested": {
              "v2": {
                "nested": {
                  "model": {
                    "nested": {
                      "settings": {
                        "nested": {
                          "rst": {
                            "nested": {
                              "common": {
                                "nested": {
                                  "FulfillmentMethodSettings": {
                                    "fields": {
                                      "promptSettings": {
                                        "type": ".squareup.devicesettings.profiles.v2.model.settings.rst.common.PromptSettings",
                                        "id": 1,
                                        "rule": "optional"
                                      }
                                    }
                                  },
                                  "PromptSettings": {
                                    "fields": {
                                      "promptingEvent": {
                                        "type": ".squareup.fulfillment.behaviors.config.PromptingEvent",
                                        "id": 1,
                                        "rule": "optional",
                                        "options": {
                                          "default": "UNSET"
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.devicesettings?.nested?.profiles?.nested?.v2?.nested?.model?.nested?.settings?.nested?.rst?.nested?.common?.nested?.FulfillmentMethodSettings && !$root.nested?.squareup?.nested?.devicesettings?.nested?.profiles?.nested?.v2?.nested?.model?.nested?.settings?.nested?.rst?.nested?.common?.nested?.PromptSettings) {
  $root.addJSON(jsonData);
}

/**
 * IMPORTANT: When Adding New Fields to Device Profiles, you MUST implement their default values at:
 *
 * /java/device-settings/src/main/java/com/squareup/devicesettings/processing/profiles/v2/defaults
 *
 * ⚠️ WARNING: Fields will not be automatically hydrated unless default values are implemented in the Java code above.
 * This is a mandatory step for all device profile settings.
 *
 * SOURCE FulfillmentMethodSettings @ squareup/devicesettings/profiles/v2/model/settings/rst/common/fulfillment_method_settings.proto at 19:1
 */
export const FulfillmentMethodSettings = $root.lookupType('squareup.devicesettings.profiles.v2.model.settings.rst.common.FulfillmentMethodSettings');
fixType(FulfillmentMethodSettings);
Builder.createAndAttachToType(FulfillmentMethodSettings);
/**
 * Settings controlling when to prompt for fulfillment method selection.
 *
 * SOURCE PromptSettings @ squareup/devicesettings/profiles/v2/model/settings/rst/common/fulfillment_method_settings.proto at 25:1
 */
export const PromptSettings = $root.lookupType('squareup.devicesettings.profiles.v2.model.settings.rst.common.PromptSettings');
fixType(PromptSettings);
Builder.createAndAttachToType(PromptSettings);